import { Event } from 'react-big-calendar';

export const WALKTHROUGH_EVENT_TYPE: number = 1;
export const SERVICE_REQUEST_EVENT_TYPE: number = 2;

export interface IProperty {
  propertyId: string;
  name: string;
}

export interface ICalendarMetadataData {
  availableEventTypes: number[];
  availableProperties: IProperty[];
}

export interface ICalendarMetadataResponse {
  message: string;
  data: ICalendarMetadataData;
}

export interface ICalendarMetadataApiResult {
  ok: boolean;
  data?: ICalendarMetadataResponse;
  error?: string;
  status?: number;
}

export interface ICalendarEventData {
  appointmentId: string;
  suiteId: string;
  eventDateTime: string;
  name: string;
  juniperEventType:
    | typeof WALKTHROUGH_EVENT_TYPE
    | typeof SERVICE_REQUEST_EVENT_TYPE;
  createdAt: string;
  propertyId: string;
  propertyName: string;
  serviceRequestId: string | null;
  walkthroughId: string | null;
  daysSinceSubmitted: number | null;
  number: string;
  ticketNumber: string | null;
  homeOwner: string;
  status: string;
  description: string;
  eventHostUserId: string;
  serviceProviderCompanyName: string | null;
  serviceProviderName: string | null;
  serviceProviderEmail: string | null;
  serviceProviderPhone: string | null;
  serviceProviderId: string | null;
}

export interface ICalendarEventsApiResponse {
  message: string;
  data: ICalendarEventData[];
}

export interface ICalendarEventsServiceResponse {
  ok: boolean;
  data?: ICalendarEventsApiResponse;
  error?: string;
  status?: number;
}

export interface ICalendarEvent extends Event {
  id: number | string;
  title: string;
  start: Date;
  end: Date;
  allDay?: boolean;
  originalEvent: ICalendarEventData;
  [key: string]: any;
}

export interface IPropertyWithState {
  id: string;
  text: string;
  enabled: boolean;
}

export interface IUniqueEventType {
  text: string;
  value: string;
  color: string;
  textColor: string;
  enabled: boolean;
}
